// The access token of the mock user.
// This access token has been randomly generated, it will not point to a known user.
export const USER_ACCESS_TOKEN = 'hmdCigKy-LsYUeGSQAkt9Yv0exKEtGjqzg5yOSwUX24.UI2oZJGcJmoT5zDMkaQfK3R1xI3HhKaQiPv4IBLYaC9';

// The JWT token of the mock user.
export const USER_JWT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY3IiOiJ1cm46aWNhYmJpOm90cDplbWFpbCIsImF0X2hhc2giOiJmRVBRX2o2bGhyVk1aMHRQb3kteU1BIiwiYXVkIjpbIjE5ZmRkNjE5LTEyNjgtNDY4Zi04ZGE1LTQzYTU5Y2FhNzBlNCJdLCJhdXRoX3RpbWUiOjE1ODg1MzExMzMsImVtYWlsIjoibmVyb0BpY2FiYmktcmVwb3J0aW5nLmNvbSIsImV4cCI6MTU4ODUzNDczNiwiZmFtaWx5X25hbWUiOiJTdWRvIiwiZ2l2ZW5fbmFtZSI6Ik5lcm8iLCJpYXQiOjE1ODg1MzExMzYsImlzcyI6Imh0dHBzOi8vYWNjb3VudHMuaWNhYmJpLmRldi8iLCJqdGkiOiI2YmM2YTEwMC1hZDViLTRjN2UtOTNhZC1iNzY4MWUwZDY1MGUiLCJuYW1lIjoiTmVybyBTdWRvIiwibm9uY2UiOiIiLCJyYXQiOjE1ODg1MzExMTgsInJvbGVzIjpbeyJuYW1lIjoiZmxlZXRBZG1pbiJ9XSwic2lkIjoiODY4ODlhZTEtMDAyMC00NGIzLTlmMmUtM2MwZTM2ZmQ5NjIyIiwic3ViIjoiY2ZkMTBmYTktODA3Mi00YmViLTg2MjYtNDJhM2Y0MDYzNTAzIn0.lFPHkYz0x-fH64NF3XLnjuyb5h241rrKoBK7_2DmHzM';

export const OAUTH2_TOKEN_RESPONSE = {
  access_token: USER_ACCESS_TOKEN,
  expires_in: 3600,
  id_token: USER_JWT_TOKEN,
  refresh_token: USER_ACCESS_TOKEN,
  scope: 'offline_access offline openid',
  token_type: 'Bearer',
};

// The payload of the decoded `USER_JWT_TOKEN`.
export const USER_JWT_PAYLOAD = {
  acr: 'urn:icabbi:otp:email',
  at_hash: 'fEPQ_j6lhrVMZ0tPoy-yMA',
  aud: [
    '19fdd619-1268-468f-8da5-43a59caa70e4',
  ],
  auth_time: 1588531133,
  email: 'nero@icabbi-reporting.com',
  exp: 1588534736,
  family_name: 'Sudo',
  given_name: 'Nero',
  iat: 1588531136,
  iss: 'https://accounts.icabbi.dev/',
  jti: '6bc6a100-ad5b-4c7e-93ad-b7681e0d650e',
  name: 'Nero Sudo',
  nonce: '',
  rat: 1588531118,
  roles: [
    {
      name: 'fleetAdmin',
    },
  ],
  sid: '86889ae1-0020-44b3-9f2e-3c0e36fd9622',
  sub: 'cfd10fa9-8072-4beb-8626-42a3f4063503',
};
